import { Input } from '@/fsd/shared/ui/input/input';
import cn from 'classnames';
import React, { InputHTMLAttributes, useEffect, useRef, useState } from 'react';
import InputMask from 'react-input-mask';
import styles from './CodeInput.module.scss';

interface ICodeInputProps {
  length?: number;
  onComplete: (code: string) => void;
  className?: string;
  status?: 'error' | 'idle' | 'pending' | 'success';
}

const CodeInput = ({
  length = 6,
  onComplete,
  className,
  status,
}: ICodeInputProps) => {
  const [value, setValue] = useState<string>('');
  const inputRef = useRef<HTMLInputElement>(null);

  const mask = '999-999';

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  useEffect(() => {
    const rawCode = value.replace(/[^0-9]/g, '');
    if (rawCode.length === length && onComplete) {
      onComplete(rawCode);
    }
  }, [value, length]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };


  return (
    <InputMask
      mask={mask}
      value={value}
      onChange={handleChange}
      alwaysShowMask={false}
      // maskChar="0"
    >
      {(inputProps: InputHTMLAttributes<HTMLInputElement>) => (
        <Input
          {...inputProps}
          type="text"
          className={cn(styles.input, className, styles[status || ''])}
          ref={inputRef}
          placeholder="000-000"
        />
      )}
    </InputMask>
  );
};

export { CodeInput };
